import { render, staticRenderFns } from "./installStep.vue?vue&type=template&id=30afd7d4&scoped=true&"
import script from "./installStep.vue?vue&type=script&lang=js&"
export * from "./installStep.vue?vue&type=script&lang=js&"
import style0 from "./installStep.vue?vue&type=style&index=0&id=30afd7d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30afd7d4",
  null
  
)

export default component.exports